module.exports = __webpack_public_path__ + "img/3.0cfd7273.jpg";